import React, { useRef } from 'react';
import {
  IonItemSliding,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonImg
} from '@ionic/react';
import { Inspection } from '../models/Inspection';

interface InspectionCardProps {
  inspection?: Inspection;
  hide: boolean;
}

const InspectionCard: React.FC<InspectionCardProps> = ({
  inspection,
  hide,
}) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);

  if (!inspection) {
    return (
      <IonList>
        {/* <IonListHeader>データがありません。</IonListHeader> */}
      </IonList>
    );
  }

  return (
    <IonItemSliding
      ref={ionItemSlidingRef}
      class={'track-' + inspection.jan.toLowerCase()}
      style={hide ? { display: 'none' } : {}}
    >
      {(inspection.image !== "") && 
      <IonItem>
        <IonImg src={inspection.image} alt="Inspection Image" style={{ width: '200px', height: '200px' }} />
      </IonItem>
      }
      <IonItem>
        <IonLabel>
          <h3 style={{ fontSize: '20px' }}>
            商品コード : {(inspection.jan !== "" && inspection.original_num !== "") ? `${inspection.jan} - ${inspection.original_num}` : inspection.jan + inspection.original_num}
          </h3>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            注文日 : {inspection.order_date}
          </p>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            数量 : {inspection.quantity}
          </p>
          <p style={{ fontSize: '20px', lineHeight: '30px' }}>
            注文番号 : {inspection.order_num}
          </p>
        </IonLabel>
      </IonItem>
    </IonItemSliding>
  );
};

export default React.memo(InspectionCard);
